module.exports = __webpack_public_path__ + "static/img/3-5.3a26f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3-5.png
// module id = CNJA
// module chunks = 1